// extracted by mini-css-extract-plugin
module.exports = {"slide":"DetailTable_slide_3ejpI","slide-reverse":"DetailTable_slide-reverse_rP8Th","fullWidth":"DetailTable_fullWidth_8GPYs","detailTable":"DetailTable_detailTable_3uHIN"};